var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-scene-overview-timelineitem"},[_c('div',{staticClass:"container",style:({
			opacity: `${100 - _vm.parallax.ratio.topToHalf * 50}%`,
			// transform: `translateY(${parallax.ratio.topToHalf * 100}%)`,
			transform: `translateY(1px)`,
		})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }